import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import TokenItem from "./TokenItem";

const Token = () => {
  const { t } = useTranslation();
  const [tokens, setTokens] = useState([]);
  const [pagination, setPagination] = useState(null);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "api/tokens")
      .then((response) => {
        setTokens(response.data.data);
        setPagination(response.data.meta.pagination);
      })
      .catch((error) => {});
  }, []);

  return (
    <div className="box">
      <div className="top">
        <div className="left">Tokens</div>
      </div>
      <div className="body">
        {tokens.length > 0 ? (
          tokens.map((value, index) => <TokenItem key={index} token={value} />)
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Token;
